export type LegendLabels = {
  available: string;
  current: string;
  unavailable: string;
  priceDisclaimer?: string;
  priceTooltip?: string;
};

export type LegendModel = {
  labels: LegendLabels;
  showPriceDisclaimer: boolean;
};

type Props = {
  showPriceDisclaimer: boolean;
  i18n: (key: string) => string;
};

export function buildLegend(props: Props): LegendModel {
  const { showPriceDisclaimer, i18n } = props;

  return {
    labels: {
      available: i18n('adder_legend_available'),
      current: i18n('adder_legend_current'),
      unavailable: i18n('adder_legend_unavailable'),
      priceDisclaimer: showPriceDisclaimer ? i18n('adder_legend_suggested_prices') : undefined,
      priceTooltip: showPriceDisclaimer ? i18n('adder_legend_suggested_prices_tooltip') : undefined,
    },
    showPriceDisclaimer,
  };
}
